import { Phone, MessageCircle, ArrowUpRight } from 'lucide-react';
import { CONTACT } from '../lib/data';
import { Reveal } from './Motion';

export default function CTASection({
  eyebrow = 'Start your enquiry',
  title = "Let's build your next print & packaging run.",
  sub = 'Low minimum order quantities, flexible production and nationwide delivery. Talk to us today — no obligation, just clear answers.',
}) {
  return (
    <section data-testid="cta-section" className="bg-primary text-primary-foreground noise">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <Reveal>
          <p className="overline">{eyebrow}</p>
          <h2 className="font-display mt-6 text-4xl md:text-6xl font-medium tracking-tight leading-[1.05] max-w-4xl">
            {title}
          </h2>
          <p className="mt-6 max-w-xl text-lg text-primary-foreground/70 leading-relaxed">{sub}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={CONTACT.tel}
              data-testid="cta-call"
              className="group inline-flex items-center gap-2 bg-white text-primary px-7 py-4 text-sm font-semibold hover:bg-accent hover:text-white transition-colors duration-300"
            >
              <Phone className="h-4 w-4" /> Call Now
              <span className="text-primary/60 group-hover:text-white/80">{CONTACT.phoneDisplay}</span>
            </a>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp"
              className="group inline-flex items-center gap-2 bg-[#25D366] text-white px-7 py-4 text-sm font-semibold hover:brightness-110 transition-all duration-300"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Us
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
